import React, { useEffect } from 'react';
import * as echarts from 'echarts';

export const DonutChart = ({ index }) => {
    useEffect(() => {
        const chart = echarts.init(document.getElementById(`donutChart${index}`));
        const resizeHandler = () => {
            chart.resize();
        };

        window.addEventListener('resize', resizeHandler);

        chart.setOption({
            tooltip: {
                trigger: 'item'
            },
            legend: {
                top: '5%',
                left: 'center'
            },
            series: [{
                name: 'Access From',
                type: 'pie',
                radius: ['40%', '70%'],
                avoidLabelOverlap: false,
                label: {
                    show: false,
                    position: 'center'
                },
                emphasis: {
                    label: {
                        show: true,
                        fontSize: '18',
                        fontWeight: 'bold'
                    }
                },
                labelLine: {
                    show: false
                },
                data: [{
                    value: 1048,
                    name: 'Класирани деца'
                },
                {
                    value: 735,
                    name: 'Записани'
                },
                ]
            }]
        });

        return () => {
            window.removeEventListener('resize', resizeHandler);
            chart.dispose();
        };
    }, []);

    return (
        <div className="col-lg-4">
            <div className="card">
                <div className="card-body">
                    <h5 className="card-title text-center">Записани <span>| Всички</span></h5>
                    <div id={`donutChart${index}`} style={{ minHeight: '300px'}} className="echart"></div>
                </div>
            </div>
        </div>
    );
};
